import type { ReactNode } from 'react'
import { Col, Form, InputNumber, Row, Switch, Typography } from 'antd'
import type { SettingsNumField, SettingsSwitchField } from './settingsFormUi'

export function QaBlock({
  title,
  desc,
  children,
}: {
  title: string
  desc?: string
  children: ReactNode
}) {
  return (
    <div className="qa-settings-block">
      <Typography.Title level={5} className="qa-settings-block-title">
        {title}
      </Typography.Title>
      {desc ? (
        <Typography.Paragraph type="secondary" className="qa-settings-block-desc">
          {desc}
        </Typography.Paragraph>
      ) : null}
      {children}
    </div>
  )
}

export function QaNumGrid({ fields }: { fields: SettingsNumField[] }) {
  return (
    <Row gutter={[20, 0]} className="qa-settings-grid">
      {fields.map((f) => (
        <Col xs={24} sm={12} key={f.name}>
          <Form.Item
            name={f.name}
            label={f.label}
            extra={f.extra}
            rules={[{ required: true, message: `请填写${f.label}` }]}
          >
            <InputNumber
              min={f.min}
              max={f.max}
              step={f.step}
              disabled={f.disabled}
              className="qa-settings-input-full"
            />
          </Form.Item>
        </Col>
      ))}
    </Row>
  )
}

export function QaSwitchList({ fields }: { fields: SettingsSwitchField[] }) {
  return (
    <div className="qa-settings-switch-list">
      {fields.map((f) => (
        <div key={f.name} className="qa-settings-switch-row">
          <div className="qa-settings-switch-text">
            <div className="qa-settings-switch-label">{f.label}</div>
            <Typography.Paragraph type="secondary" className="qa-settings-switch-extra">
              {f.extra}
            </Typography.Paragraph>
          </div>
          <Form.Item name={f.name} valuePropName="checked" noStyle>
            <Switch
              checkedChildren={f.checkedChildren}
              unCheckedChildren={f.unCheckedChildren}
              disabled={f.disabled}
            />
          </Form.Item>
        </div>
      ))}
    </div>
  )
}
